import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What does a web development company do?",
    answer: `<p>A professional web development company helps you create a website or an application for business or personal use. The procedure of developing a website varies from one company to another, but most web development agencies follow similar procedures. However, TekRevol customized its development approach according to the objective of each project to ensure an impactful product in the market.</p>`,
  },
  {
    question: "Does TekRevol offer NDAs for web development projects?",
    answer: `<p>Yes, TekRevol provides Non-Disclosure Agreements (NDAs) to ensure the confidentiality and security of your sensitive information throughout the web development process.</p>`,
  },
  {
    question: "What is the process of web development at TekRevol?",
    answer: ` <p>At TekRevol, our web development process is structured and comprehensive. It begins with a thorough analysis of your requirements, followed by strategic planning, design, development, testing, and deployment. Our team ensures clear communication, regular updates, and feedback loops to deliver a high-quality website that meets your objectives and drive desired results.</p>`,
  },
  {
    question: "What are the technologies used for web development?",
    answer: `<p>TekRevol uses a wide range of modern, productive technologies for web development, including but not limited to HTML5, CSS3, JavaScript, PHP, Python, Ruby on Rails, React, Angular, Node.js, and more. We stay updated with the latest trends and tools to ensure your website is built using the most efficient and effective technologies available.</p>`,
  },
  {
    question: "How much does web development cost?",
    answer: `<p>The cost of web development at TekRevol varies based on the complexity, features, and scale of the project. The starting cost of template-based or small-scale web development is around $1,000 - $5,000. Whereas a full-scale e-commerce store can cost between $20,000 - $30,000 (for 100-1000 products). We offer customized solutions tailored to your needs and budget. To get an accurate quote, we recommend scheduling a consultation with our team to discuss your requirements in detail.</p>`,
  },
  {
    question: "How long does it take to develop a website?",
    answer: ` <p>The timeline for website development depends on the scope of the project, features required, and client feedback. On average, a standard website can take anywhere from 4 to 12 weeks to develop. However, websites with extensive features and customized functionalities could extend the timeline. Get in touch with our project managers to get the actual estimate for your web development needs.</p>`,
  },
  {
    question: "Does TekRevol offer a free consultation for web development?",
    answer: ` <p>Yes, TekRevol provides a free consultation for web development projects. Our team of experts will assess your requirements, discuss your goals, and provide recommendations tailored to your needs. This initial consultation is a crucial step in understanding your project and ensuring a successful collaboration.</p>`,
  },
  {
    question:
      "Does TekRevol offer ongoing support and maintenance for the website?",
    answer: `<p>Yes, TekRevol offers comprehensive ongoing support and maintenance services for websites we develop. Our team is dedicated to ensuring your website remains secure, up-to-date, and optimized for performance. We provide regular updates, backups, security checks, and technical support to keep your website running smoothly.</p>`,
  },
  {
    question:
      "What is the difference between website development and website design?",
    answer: `<p>Website development focuses on the technical aspects of building a website, including coding, functionality, and performance. On the other hand, website design is more about visual aesthetics, user experience, and interface design. While development deals with functionality, design enhances the look and feel of the website. At TekRevol, we excel in both development and design to create websites that are both visually appealing and functionally robust.</p>`,
  },
  {
    question: "Is SEO important after website development?",
    answer: `<p>Yes, SEO (Search Engine Optimization) is crucial after website development to ensure your website ranks well in search engine results and attracts organic traffic. TekRevol offers SEO services to optimize your website for search engines, improve visibility, and drive relevant traffic to your site. By implementing SEO strategies post-development, you can enhance your online presence and reach a wider audience effectively.</p>`,
  },
  {
    question: "How do I find a web development agency?",
    answer: `<p>There can be different ways to find among the web development firms. However, it is better to use search engines like Google to discover freelance web designers, as well as web design agencies. You can also have deep insights about companies from review platforms like Clutch to find web design agencies. Here you can view the agency pricing, reviews, and portfolio.</p>`,
  },
  {
    question: "Why should you hire TekRevol as your web development firm?",
    answer: `<p>TekRevol's web development expertise lies in our proficiency with React, Angular, Node.js, and Laravel, combined with our experience in designing and developing scalable, secure, and high-performance websites. Our team's focus on HTML5, CSS3, and JavaScript enables us to craft visually appealing and user-friendly interfaces, while our knowledge of PHP, Python, and Ruby on Rails allows us to develop robust and efficient back-end systems. With a proven track record of successful web development projects across diverse industries with excellence our top priority for the past 6 years. We have the prowess to bring your vision to life and drive your online success.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Web Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
